import { protocol } from './protocol';

export type Message = protocol.Config | protocol.Scene | protocol.Frame;

/**
 * Attempts to decode a single protocol message from the ArrayBuffer provided
 *
 * Returns the protocol class instance for the message, or null if a valid
 * message could not be parsed from the buffer.
 */
export function decodeMessageFromBuffer(buffer: ArrayBuffer) {
  const bufferView = new Uint8Array(buffer);

  // New-style messages, wrapped in high-level SensorData message
  try {
    const sensorDataMessage = protocol.SensorData.decode(bufferView);
    const messageTypeName = sensorDataMessage.sensordata;
    if (!messageTypeName) {
      throw new Error('Unable to parse message as SensorData');
    }
    switch (messageTypeName) {
      case 'message_config': {
        if (!sensorDataMessage.message_config) return null;
        return new protocol.Config(sensorDataMessage.message_config);
      }
      case 'message_scene': {
        if (!sensorDataMessage.message_scene) return null;
        return new protocol.Scene(sensorDataMessage.message_scene);
      }
      case 'message_frame': {
        if (!sensorDataMessage.message_frame) return null;
        return new protocol.Frame(sensorDataMessage.message_frame);
      }
      default: {
        return null;
      }
    }
  } catch (err) {
    // If error is caught, try to parse the buffer as the old-style, unwrapped Frame
    try {
      const frameMessage = protocol.Frame.decode(bufferView);
      return frameMessage;
    } catch (err) {
      return null;
    }
  }
}
